export default "__VITE_ASSET__DX2XLh5a__"